import { render, staticRenderFns } from "./Optimizing.vue?vue&type=template&id=09f9805c&scoped=true&"
import script from "./Optimizing.vue?vue&type=script&lang=ts&"
export * from "./Optimizing.vue?vue&type=script&lang=ts&"
import style0 from "./Optimizing.vue?vue&type=style&index=0&id=09f9805c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f9805c",
  null
  
)

export default component.exports